type ValidatePasswordResetTokenResponse = {
  email: string
  firstName: string
  lastName: string
}

export const validatePasswordResetToken = async (
  token: string
) => {
  const { body } =
    await api.post<ValidatePasswordResetTokenResponse>(
      "/validate-password-reset-token/",
      { body: { token } }
    )
  return body
}
